import { Table } from 'antd';
import { LICENSE_TYPES } from '../constants';

export default function ProductBundleListTable({ items }) {
  const bundleColumns = [
    {
      title: 'Product',
      dataIndex: ['bundle_item', 'product'],
      key: 'product',
    },
    {
      title: 'Name',
      dataIndex: ['bundle_item', 'name'],
      key: 'name',
    },
    {
      title: 'SKU',
      dataIndex: ['bundle_item', 'sku'],
      key: 'sku'
    },
    {
      title: 'Description',
      dataIndex: ['bundle_item', 'description'],
      key: 'description'
    },
    {
      title: 'Version',
      dataIndex: ['bundle_item', 'version'],
      key: 'version'
    },
    {
      title: 'Original Price',
      dataIndex: ['bundle_item', 'price'],
      key: 'price',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    {
      title: 'LicenseType',
      dataIndex: ['bundle_item', 'license_type'],
      key: 'license_type',
      render: (value) => {
        const match = LICENSE_TYPES.find((v) => +v.value === +value)
        return match ? match.label : null;
      }
    },
  ];
  return <Table rowKey="id" columns={bundleColumns} dataSource={items} pagination={false} size="small"/>
}